var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OIDC } from './OIDC';
import log from 'loglevel';
var OAuthProvider = /** @class */ (function () {
    function OAuthProvider(config) {
        var _this = this;
        this.type = 'oauth';
        this._user = null;
        this.trySilentRefresh = function () { return _this.manager.signinRedirect(); };
        this.login = function () {
            _this.manager.signinRedirect();
        };
        this.logout = function () {
            _this.manager.signoutRedirect();
        };
        this.completeLogin = function (url) { return __awaiter(_this, void 0, void 0, function () {
            var user;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.authorized) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.manager.signinRedirectCallback(url)];
                    case 1:
                        user = _a.sent();
                        this.setUser(user);
                        return [2 /*return*/, user];
                    case 2: return [2 /*return*/, this.user];
                }
            });
        }); };
        this.canAccess = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.authorized) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.tryLoadUser()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        // check access grant
                        if (this.authorized || !this.config.automaticLogin) {
                            return [2 /*return*/, true];
                        }
                        // redirect to login
                        return [4 /*yield*/, this.login()];
                    case 3:
                        // redirect to login
                        _a.sent();
                        return [2 /*return*/, false];
                }
            });
        }); };
        this.httpRequestHandler = function (request) { return __awaiter(_this, void 0, void 0, function () {
            var headers, authorization;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.user && !this.authorized)) return [3 /*break*/, 2];
                        // try refresh token
                        return [4 /*yield*/, this.manager.signinRedirect()];
                    case 1:
                        // try refresh token
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        headers = request.headers;
                        authorization = this.getHttpRequestHeader();
                        request.headers = !authorization
                            ? headers
                            : __assign(__assign({}, (headers || {})), { Authorization: authorization });
                        return [2 /*return*/, request];
                }
            });
        }); };
        this.httpErrorHandler = function (error) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(error.response && error.response.status === 401)) return [3 /*break*/, 4];
                        log.warn('Auth: Request error happend');
                        log.warn(this.user);
                        log.warn(error);
                        if (!this.user) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.manager.signoutRedirect()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.login()];
                    case 3:
                        _a.sent();
                        // freeze response
                        // TODO: research usages looks weird
                        return [2 /*return*/, new Promise(function () { return null; })];
                    case 4: return [2 /*return*/, Promise.reject(error)];
                }
            });
        }); };
        this.config = config;
        var fullConfig = this.getAuthConfig();
        this.manager = new OIDC(fullConfig);
        // TODO: research usages and remove
        this.tryLoadUser();
        window['USER_MANAGER'] = this.manager;
    }
    Object.defineProperty(OAuthProvider.prototype, "user", {
        get: function () {
            return this._user;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OAuthProvider.prototype, "profile", {
        get: function () {
            return this.user && this.user.profile;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OAuthProvider.prototype, "authorized", {
        get: function () {
            return !!this.user && !this.user.expired;
        },
        enumerable: false,
        configurable: true
    });
    OAuthProvider.prototype.removeUser = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                // in fact we just remove our data from storage
                this.manager.clearStorage();
                this.setUser(null);
                return [2 /*return*/];
            });
        });
    };
    // TODO: syncing with variables is bad idea userLoading$ silentRefreshing$ but need usages research
    OAuthProvider.prototype.tryLoadUser = function (refresh) {
        if (refresh === void 0) { refresh = false; }
        return __awaiter(this, void 0, void 0, function () {
            var user;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.userLoading$)
                            return [2 /*return*/, this.userLoading$];
                        return [4 /*yield*/, this.manager.getUser()];
                    case 1:
                        user = _a.sent();
                        if (user && refresh) {
                            this.trySilentRefresh();
                        }
                        if (user)
                            this._user = user;
                        this.userLoading$ = undefined;
                        return [2 /*return*/];
                }
            });
        });
    };
    OAuthProvider.prototype.setUser = function (user) {
        this._user = user;
    };
    OAuthProvider.prototype.mapUri = function (path) {
        if (path.startsWith('http')) {
            return path;
        }
        return "" + window.location.origin + (process.env.PUBLIC_URL || '') + (path.startsWith('/') ? '' : '/') + path;
    };
    OAuthProvider.prototype.getAuthConfig = function () {
        var config = __assign(__assign({ response_type: 'id_token token', scope: 'openid profile', monitorSession: false, automaticSilentRenew: true, clockSkew: 60000, autorizationFlow: 'implicit' }, this.config), { post_logout_redirect_uri: this.mapUri('/'), redirect_uri: this.mapUri('/auth/callback'), silent_redirect_uri: this.mapUri('/oidc-silent-refresh.html') });
        return config;
    };
    OAuthProvider.prototype.getHttpRequestHeader = function () {
        if (this.user && this.user.data.access_token) {
            return this.user.data.token_type + " " + this.user.data.access_token;
        }
        return null;
    };
    return OAuthProvider;
}());
export { OAuthProvider };
//# sourceMappingURL=oauth.provider.js.map